$(".close-popup").click(function(){
	$(this).parents('.popup').fadeOut('slow');
});
